import { tail, isEmpty, head } from 'ramda';

function asyncForEach(callback, arr, delay) {
  if (isEmpty(arr)) return;
  callback(head(arr));
  setTimeout(() => asyncForEach(callback, tail(arr), delay), delay);
}

export default asyncForEach;
